/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ConnectionPeerFirstName } from './connectionPeerFirstName';
import type { ConnectionPeerEmail } from './connectionPeerEmail';
import type { ConnectionPeerPhone } from './connectionPeerPhone';
import type { ConnectionPeerWhatsapp } from './connectionPeerWhatsapp';
import type { ConnectionPeerProfilePhotoBlobPath } from './connectionPeerProfilePhotoBlobPath';
import type { ConnectionPeerProfilePhotoUrl } from './connectionPeerProfilePhotoUrl';

/**
 * The other student on a connection edge.
 */
export interface ConnectionPeer {
  firstName?: ConnectionPeerFirstName;
  email?: ConnectionPeerEmail;
  phone?: ConnectionPeerPhone;
  whatsapp?: ConnectionPeerWhatsapp;
  profilePhotoBlobPath?: ConnectionPeerProfilePhotoBlobPath;
  profilePhotoUrl?: ConnectionPeerProfilePhotoUrl;
}
